import React from 'react'
import OurStory from '@components/our-story'
import MainLayout from '@layouts/main-layout'

const OurStoryPage = () => {
  return (
    <>
      <OurStory />
    </>
  )
}

OurStoryPage.getLayout = (page: React.ReactElement) => {
  return <MainLayout>{page}</MainLayout>
}

export default OurStoryPage
